export default __webpack_public_path__ + "static/media/code-1.5f190079.jpeg";